<template>
  <div class="wrapper">
    <header class="bg">
      <h2>UED-CDN</h2>
      <div class="logo-page"><img src="../assets/images/baohe.png" /></div>
      <p>宝盒SDK</p>
    </header>
    <section>
      <file-list :fileList="fileList"></file-list>
    </section>
  </div>
</template>

<script>
const ur = "https://uedcdn.zto.com/static/baohe/";
export default {
  name: "index",
  data() {
    return {
      fileList: [
        {
          label: "1.11.0",
          linkList: [ur + "1.11.0/zt-sdk.js", ur + "1.11.0/zt-sdk.min.js"]
        },
        {
          label: "1.10.0",
          linkList: [ur + "1.10.0/zt-sdk.js", ur + "1.10.0/zt-sdk.min.js"]
        },
        {
          label: "1.9.4",
          linkList: [ur + "1.9.4/zt-sdk.min.js"]
        },
        {
          label: "1.9.3",
          linkList: [ur + "1.9.3/zt-sdk.js", ur + "1.9.3/zt-sdk.min.js"]
        },
        {
          label: "1.9.1",
          linkList: [ur + "1.9.1/zt-sdk.js", ur + "1.9.1/zt-sdk.min.js"]
        },
        {
          label: "1.9.0",
          linkList: [ur + "1.9.0/zt-sdk.js", ur + "1.9.0/zt-sdk.min.js"]
        },
        {
          label: "1.8.0",
          linkList: [ur + "1.8.0/zt-sdk.js", ur + "1.8.0/zt-sdk.min.js"]
        },
        {
          label: "1.7.0",
          linkList: [ur + "1.7.0/zt-sdk.js", ur + "1.7.0/zt-sdk.min.js"]
        },
        {
          label: "1.6.1",
          linkList: [ur + "1.6.1/zt-sdk.js", ur + "1.6.1/zt-sdk.min.js"]
        },
        {
          label: "1.6.0",
          linkList: [ur + "1.6.0/zt-sdk.js", ur + "1.6.0/zt-sdk.min.js"]
        },
        {
          label: "1.5.0",
          linkList: [ur + "1.5.0/zt-sdk.js", ur + "1.5.0/zt-sdk.min.js"]
        },
        {
          label: "1.4.4",
          linkList: [ur + "1.4.4/zt-sdk.js", ur + "1.4.4/zt-sdk.min.js"]
        },
        {
          label: "1.4.3",
          linkList: [ur + "1.4.3/zt-sdk.js", ur + "1.4.3/zt-sdk.min.js"]
        },
        {
          label: "1.4.2",
          linkList: [ur + "1.4.2/zt-sdk.js", ur + "1.4.2/zt-sdk.min.js"]
        },
        {
          label: "1.4.1",
          linkList: [ur + "1.4.1/zt-sdk.js", ur + "1.4.1/zt-sdk.min.js"]
        },
        {
          label: "1.4.0",
          linkList: [ur + "1.4.0/zt-sdk.js", ur + "1.4.0/zt-sdk.min.js"]
        },
        {
          label: "1.3.2",
          linkList: [ur + "1.3.2/zt-sdk.js", ur + "1.3.2/zt-sdk.min.js"]
        },
        {
          label: "1.3.1",
          linkList: [ur + "1.3.1/zt-sdk.js", ur + "1.3.1/zt-sdk.min.js"]
        },
        {
          label: "1.3.0",
          linkList: [ur + "1.3.0/zt-sdk.js", ur + "1.3.0/zt-sdk.min.js"]
        },
        {
          label: "1.2.1",
          linkList: [ur + "1.2.1/zt-sdk.js", ur + "1.2.1/zt-sdk.min.js"]
        },
        {
          label: "1.2.0",
          linkList: [ur + "1.2.0/zt-sdk.js", ur + "1.2.0/zt-sdk.min.js"]
        },
        {
          label: "1.1.9",
          linkList: [ur + "1.1.9/zt-sdk.js", ur + "1.1.9/zt-sdk.min.js"]
        },
        {
          label: "1.1.8",
          linkList: [ur + "1.1.8/zt-sdk.js", ur + "1.1.8/zt-sdk.min.js"]
        },
        {
          label: "1.1.7",
          linkList: [ur + "1.1.7/zt-sdk.js", ur + "1.1.7/zt-sdk.min.js"]
        },
        {
          label: "1.1.6",
          linkList: [ur + "1.1.6/zt-sdk.js", ur + "1.1.6/zt-sdk.min.js"]
        },
        {
          label: "1.1.5",
          linkList: [ur + "1.1.5/zt-sdk.js", ur + "1.1.5/zt-sdk.min.js"]
        },
        {
          label: "1.1.4",
          linkList: [ur + "1.1.4/zt-sdk.js", ur + "1.1.4/zt-sdk.min.js"]
        },
        {
          label: "1.1.3",
          linkList: [ur + "1.1.3/zt-sdk.js", ur + "1.1.3/zt-sdk.min.js"]
        },
        {
          label: "1.1.2",
          linkList: [ur + "1.1.2/zt-sdk.js", ur + "1.1.2/zt-sdk.min.js"]
        },
        {
          label: "1.1.1",
          linkList: [ur + "1.1.1/zt-sdk.js", ur + "1.1.1/zt-sdk.min.js"]
        },
        {
          label: "1.1.0",
          linkList: [ur + "1.1.0/zt-sdk.js", ur + "1.1.0/zt-sdk.min.js"]
        },
        {
          label: "1.0.9",
          linkList: [ur + "1.0.9/zt-sdk.js", ur + "1.0.9/zt-sdk.min.js"]
        },
        {
          label: "1.0.9-beta.0",
          linkList: [
            ur + "1.0.9-beta.0/zt-sdk.js",
            ur + "1.0.9-beta.0/zt-sdk.min.js"
          ]
        },
        {
          label: "1.0.8",
          linkList: [ur + "1.0.8/zt-sdk.js", ur + "1.0.8/zt-sdk.min.js"]
        },
        {
          label: "1.0.8-beta.1",
          linkList: [
            ur + "1.0.8-beta.1/zt-sdk.js",
            ur + "1.0.8-beta.1/zt-sdk.min.js"
          ]
        },
        {
          label: "1.0.8-beta.0",
          linkList: [
            ur + "1.0.8-beta.0/zt-sdk.js",
            ur + "1.0.8-beta.0/zt-sdk.min.js"
          ]
        },
        {
          label: "1.0.7",
          linkList: [ur + "1.0.7/zt-sdk.js", ur + "1.0.7/zt-sdk.min.js"]
        },
        {
          label: "1.0.7-alpha.3",
          linkList: [
            ur + "1.0.7-alpha.3/zt-sdk.js",
            ur + "1.0.7-alpha.3/zt-sdk.min.js"
          ]
        },
        {
          label: "1.0.7-alpha.2",
          linkList: [
            ur + "1.0.7-alpha.2/zt-sdk.js",
            ur + "1.0.7-alpha.2/zt-sdk.min.js"
          ]
        },
        {
          label: "1.0.7-alpha.1",
          linkList: [
            ur + "1.0.7-alpha.1/zt-sdk.js",
            ur + "1.0.7-alpha.1/zt-sdk.min.js"
          ]
        },
        {
          label: "1.0.7-alpha.0",
          linkList: [
            ur + "1.0.7-alpha.0/zt-sdk.js",
            ur + "1.0.7-alpha.0/zt-sdk.min.js"
          ]
        },
        {
          label: "1.0.6",
          linkList: [ur + "1.0.6/zt-sdk.js", ur + "1.0.6/zt-sdk.min.js"]
        },
        {
          label: "1.0.5",
          linkList: [ur + "1.0.5/zt-sdk.js", ur + "1.0.5/zt-sdk.min.js"]
        },
        {
          label: "1.0.4",
          linkList: [ur + "1.0.4/zt-sdk.js", ur + "1.0.4/zt-sdk.min.js"]
        },
        {
          label: "1.0.3",
          linkList: [ur + "1.0.3/zt-sdk.js", ur + "1.0.3/zt-sdk.min.js"]
        },
        {
          label: "1.0.1",
          linkList: [ur + "1.0.1/zt-sdk.js", ur + "1.0.1/zt-sdk.min.js"]
        },
        {
          label: "1.0.0",
          linkList: [ur + "1.0.0/zt-sdk.js", ur + "1.0.0/zt-sdk.min.js"]
        }
      ]
    };
  }
};
</script>



// WEBPACK FOOTER //
// src/view/ListBaohe.vue